import { render, staticRenderFns } from "./contactDir_p.vue?vue&type=template&id=f92f6c42"
import script from "./contactDir_p.vue?vue&type=script&lang=js"
export * from "./contactDir_p.vue?vue&type=script&lang=js"
import style0 from "./contactDir_p.vue?vue&type=style&index=0&id=f92f6c42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports